import styled from "styled-components";
import { DefaultParagraphMediumFactory, DefaultTitleLargeFactory } from "../core/Typograph/Typograph.Style";

export const CardProductSelectContainer = styled.div(({theme}) => ({
    display: "flex",
    alignItems: "center",
    gap: "32px",
    alignSelf: "stretch",
    marginTop: "32px",

    [theme.breakpoint.lg()]: {
        display: "flex",
        justifyContent: "space-between",
        margin: "60px 0",
    },
}))

export const CardProductSelectMainContent = styled.div(({theme}) => ({
    display: "flex",
    padding: "24px",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: 'space-between',
    border: "1px solid #D1DBE3",
    borderRadius: "8px",
    maxHeight: '100%',
    flex: "1 0 0",
    alignSelf: "stretch",
    height: "auto",
    
    [theme.breakpoint.lg()]: {
        width: "336px",
    },
}))

export const CardProductSelectContent = styled.div(() => ({
    gap: "12px",
    display: "flex",
    flexDirection: "column",
    marginBottom: "32px",
}))

export const CardProductSelectIcon = styled.span(() => ({
    width: "48px",
    height: "48px",
    marginBottom: "8px",
}))

export const CardProductSelectTitle = styled.h3(({theme}) => ({
    ...DefaultTitleLargeFactory({theme})
}))

export const CardProductSelectDescription = styled.span(({theme}) => ({
    ...DefaultParagraphMediumFactory({theme})
}))

export const CardProductSelectDivider = styled.div(() => ({
    border: "1px solid #E3E0E2",
    height: "1px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    
}))